export default "__VITE_ASSET__C_gqWr1Y__"